import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=21fa32e0"
import script from "./PermissionModal.vue?vue&type=script&lang=js"
export * from "./PermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports